export const LOGO_URL = "https://customer-assets-4nw71qhi.emergentagent.net/job_valuelix-demo/artifacts/3bu8dmco_file_00000000036c81fa88982e548bcd3efb.png";
export const HERO_IMG = "https://static.prod-images.emergentagent.com/jobs/a492165f-2bb9-4805-98b4-acca347d604f/images/f282b75e3262b314da2597142d1868949e42e7e9bb2d548896241420e34ab451.jpeg";

const IMG = "https://static.prod-images.emergentagent.com/jobs/a492165f-2bb9-4805-98b4-acca347d604f/images/";

export const CATEGORIES = [
  { id: "mobile", icon: "Smartphone", conditionSet: "standard", image: IMG + "d60c2ca4c3ef087b58dc235f5fba5bae348e000fa62af5bbccabf8c2b8f788f7.jpeg" },
  { id: "laptop", icon: "Laptop", conditionSet: "standard", image: IMG + "8f5151aef32803a7c21c3ecc2e78b5cb342e71c119e08151b059e12ab3d02fcc.jpeg" },
  { id: "tablet", icon: "TabletSmartphone", conditionSet: "standard", image: IMG + "6e9beb1fa78fe7498e35d260d6e71f9702ed19ade97c78abf612a51c2791c15f.jpeg" },
  { id: "tv", icon: "Tv", conditionSet: "tv", image: IMG + "1bfb10906d757ad6798be60c931bfb21feebcdf2379781b71616cb80ed7be45b.jpeg" },
  { id: "gaming", icon: "Gamepad2", conditionSet: "standard", image: IMG + "a179024449997520ee16e48d06737cf9b7d1ca7b860a7288aa3b544f32c2cbac.jpeg" },
  { id: "camera", icon: "Camera", conditionSet: "standard", image: IMG + "b3a38a671728360684734c31920326de45778344212aadbcbbb2b5839839538e.jpeg" },
  { id: "smartwatch", icon: "Watch", conditionSet: "standard", image: IMG + "2b56efc6bc2a26e690ee41646f31953472c046521c4966873622bb305474422e.jpeg" },
  { id: "earbuds", icon: "Headphones", conditionSet: "wearable", image: IMG + "93a90c8b83150eb9a377cbee7970fd6bfd32d581c24cc1c17f10d0ff0337477d.jpeg" },
  { id: "appliance", icon: "WashingMachine", conditionSet: "appliance", image: IMG + "d30c61e39de790b5d9dd0cf83acf98770f50374051d29de0235349e8811070a8.jpeg" },
  { id: "accessory", icon: "Cable", conditionSet: "wearable", image: IMG + "f746e0a78f5badb7ca8dd730ddb22e51c781fa6b50a31014a1d81402b4fb22ab.jpeg" },
  { id: "furniture", icon: "Sofa", conditionSet: "standard", image: "/img/furniture.svg" },
  { id: "others", icon: "Package", conditionSet: "standard", image: IMG + "9d1a064f4930f577722ed70071ca88ef6ab2753db15d68b5e262dae0a132fbe1.jpeg" },
];

export const CONDITION_SETS = {
  standard: ["like_new", "good", "fair", "damaged"],
  tv: ["working_perfectly", "minor_cosmetic", "display_issue", "not_working"],
  appliance: ["working_perfectly", "minor_issues", "major_issues", "not_working"],
  wearable: ["like_new", "good", "visible_wear", "damaged"],
};

// Purchase years: this year and the 8 years before it (ages 0-8), then "older".
// Every year gives a different price (same list as the backend /api/meta).
const THIS_YEAR = new Date().getFullYear();
export const YEARS = [...Array.from({ length: 9 }, (_, i) => String(THIS_YEAR - i)), "older"];

// Battery health is asked (optionally) only where it matters.
export const BATTERY_CATEGORIES = ["mobile", "laptop", "tablet", "smartwatch"];
export const BATTERY_OPTIONS = ["bat_90", "bat_85", "bat_80", "bat_low", "bat_unknown"];

const lc = (s) => (s || "").toLowerCase();

// ---- Auto-detection helpers (model-first intelligence) ----
const detectStorage = (keys) => (m) => {
  m = lc(m);
  if (/\b(1\s?tb)\b/.test(m) && keys.st_1tb) return keys.st_1tb;
  if (/\b512\s?gb\b/.test(m) && keys.st_512) return keys.st_512;
  if (/\b256\s?gb\b/.test(m) && keys.st_256) return keys.st_256;
  if (/\b128\s?gb\b/.test(m) && keys.st_128) return keys.st_128;
  if (/\b64\s?gb\b/.test(m) && keys.st_64) return keys.st_64;
  if (/\b32\s?gb\b/.test(m) && keys.st_32) return keys.st_32;
  return null;
};

const detectScreen = (m) => {
  m = lc(m);
  let n = null;
  const mt = m.match(/(\d{2,3})\s?(inch|"|”|-inch|in\b)/);
  if (mt) n = parseInt(mt[1], 10);
  if (!n) { const q = m.match(/\b(24|32|40|43|50|55|65|75|77|85)\b/); if (q) n = parseInt(q[1], 10); }
  if (!n) return null;
  if (n >= 72) return "scr_75";
  if (n >= 60) return "scr_65";
  if (n >= 53) return "scr_55";
  if (n >= 48) return "scr_50";
  if (n >= 42) return "scr_43";
  if (n >= 38) return "scr_40";
  if (n >= 30) return "scr_32";
  return "scr_24";
};

// ---- Category spec fields. Each: {field, options, detect?} ----
export const SPECS = {
  mobile: [
    { field: "storage", options: ["st_32", "st_64", "st_128", "st_256", "st_512", "st_1tb"],
      detect: detectStorage({ st_32: "st_32", st_64: "st_64", st_128: "st_128", st_256: "st_256", st_512: "st_512", st_1tb: "st_1tb" }) },
  ],
  laptop: [
    { field: "ram", options: ["lram_4", "lram_8", "lram_16", "lram_32", "lram_64"],
      detect: (m) => { m = lc(m);
        const rm = m.match(/(\d+)\s?gb\s?ram/) || m.match(/(\d+)\s?gb\s?[/+,]\s?\d+\s?(gb|tb)/);
        const r = rm ? parseInt(rm[1], 10) : null;
        return { 4: "lram_4", 8: "lram_8", 16: "lram_16", 32: "lram_32", 64: "lram_64" }[r] || null; } },
    { field: "storage", options: ["lst_256ssd", "lst_512ssd", "lst_1tbhdd", "lst_1tbssd", "lst_2tb"],
      detect: (m) => { m = lc(m);
        if (/2\s?tb/.test(m)) return "lst_2tb";
        if (/1\s?tb\s?hdd/.test(m)) return "lst_1tbhdd";
        if (/1\s?tb/.test(m)) return "lst_1tbssd";
        if (/512\s?gb/.test(m)) return "lst_512ssd";
        if (/256\s?gb/.test(m)) return "lst_256ssd";
        return null; } },
    { field: "processor", options: ["cpu_i3", "cpu_i5", "cpu_i7", "cpu_i9", "cpu_r3", "cpu_r5", "cpu_r7", "cpu_m1", "cpu_m2", "cpu_m3"],
      detect: (m) => { m = lc(m);
        if (/\bm3\b/.test(m)) return "cpu_m3";
        if (/\bm2\b/.test(m)) return "cpu_m2";
        if (/\bm1\b/.test(m)) return "cpu_m1";
        if (/i9/.test(m)) return "cpu_i9";
        if (/i7/.test(m)) return "cpu_i7";
        if (/i5/.test(m)) return "cpu_i5";
        if (/i3/.test(m)) return "cpu_i3";
        if (/ryzen\s?7/.test(m)) return "cpu_r7";
        if (/ryzen\s?5/.test(m)) return "cpu_r5";
        if (/ryzen\s?3/.test(m)) return "cpu_r3";
        return null; } },
  ],
  tablet: [
    { field: "storage", options: ["tst_32", "tst_64", "tst_128", "tst_256", "tst_512"],
      detect: detectStorage({ st_32: "tst_32", st_64: "tst_64", st_128: "tst_128", st_256: "tst_256", st_512: "tst_512" }) },
    { field: "connectivity", options: ["tcon_wifi", "tcon_cell"],
      detect: (m) => { m = lc(m); if (/cellular|lte|5g|sim/.test(m)) return "tcon_cell"; if (/wifi|wi-fi/.test(m)) return "tcon_wifi"; return null; } },
  ],
  tv: [
    { field: "screen_size", options: ["scr_24", "scr_32", "scr_40", "scr_43", "scr_50", "scr_55", "scr_65", "scr_75"], detect: detectScreen },
  ],
  gaming: [
    { field: "edition", options: ["ged_disc", "ged_digital"],
      detect: (m) => { m = lc(m); if (/digital/.test(m)) return "ged_digital"; if (/disc/.test(m)) return "ged_disc"; return null; } },
  ],
  camera: [],
  smartwatch: [
    { field: "connectivity", options: ["wcon_gps", "wcon_cell"],
      detect: (m) => { m = lc(m); if (/cellular|lte|5g/.test(m)) return "wcon_cell"; if (/gps/.test(m)) return "wcon_gps"; return null; } },
  ],
  earbuds: [],
  accessory: [],
  others: [],
  furniture: [
    { field: "furniture_type", options: ["fur_almirah", "fur_sofa", "fur_bed", "fur_table", "fur_chair", "fur_dining", "fur_other"],
      detect: (m) => { m = lc(m);
        if (/almirah|wardrobe|cupboard|almari/.test(m)) return "fur_almirah";
        if (/sofa|couch|recliner/.test(m)) return "fur_sofa";
        if (/\bbed\b|cot|mattress|diwan|divan/.test(m)) return "fur_bed";
        if (/dining/.test(m)) return "fur_dining";
        if (/chair|stool/.test(m)) return "fur_chair";
        if (/table|desk/.test(m)) return "fur_table";
        return null; } },
  ],
};

// Home appliances: pick type first (or auto-detected), then only resale-relevant fields.
// TV removed — it is a separate top-level category. "Other" is never a default.
export const APPLIANCE_TYPES = ["app_fridge", "app_wash", "app_ac", "app_micro", "app_other"];

export function detectApplianceType(m) {
  m = lc(m);
  if (/air.?conditioner|\bac\b|\bton\b|\bsplit\b|\bwindow\b/.test(m)) return "app_ac";
  if (/washing|washer|front\s?load|top\s?load|fully\s?automatic|semi\s?automatic|\d(\.\d)?\s?kg/.test(m)) return "app_wash";
  if (/microwave|convection|\bgrill\b|\bsolo\b|\boven\b/.test(m)) return "app_micro";
  if (/refrigerator|fridge|single\s?door|double\s?door|side.?by.?side|french\s?door|\d{3}\s?l\b|\bl\s?door/.test(m)) return "app_fridge";
  return null;
}

export const APPLIANCE_SPECS = {
  app_fridge: [
    { field: "capacity", options: ["fcap_small", "fcap_medium", "fcap_large"],
      detect: (m) => { m = lc(m); const q = m.match(/(\d{2,4})\s?(l|ltr|litre|liter)/); if (!q) return null; const n = parseInt(q[1], 10); return n < 200 ? "fcap_small" : n <= 400 ? "fcap_medium" : "fcap_large"; } },
    { field: "fridge_type", options: ["ft_single", "ft_double", "ft_sbs", "ft_french"],
      detect: (m) => { m = lc(m); if (/french/.test(m)) return "ft_french"; if (/side.?by.?side|sbs/.test(m)) return "ft_sbs"; if (/double|2\s?door/.test(m)) return "ft_double"; if (/single|1\s?door/.test(m)) return "ft_single"; return null; } },
  ],
  app_wash: [
    { field: "capacity", options: ["wcap_small", "wcap_medium", "wcap_large"],
      detect: (m) => { m = lc(m); const q = m.match(/(\d(\.\d)?)\s?kg/); if (!q) return null; const n = parseFloat(q[1]); return n < 7 ? "wcap_small" : n <= 8 ? "wcap_medium" : "wcap_large"; } },
    { field: "wm_type", options: ["wm_fully", "wm_semi", "wm_front", "wm_top"],
      detect: (m) => { m = lc(m); if (/front\s?load/.test(m)) return "wm_front"; if (/top\s?load/.test(m)) return "wm_top"; if (/semi/.test(m)) return "wm_semi"; if (/fully/.test(m)) return "wm_fully"; return null; } },
  ],
  app_ac: [
    { field: "ac_capacity", options: ["acc1", "acc15", "acc2", "accother"],
      detect: (m) => { m = lc(m); if (/1\.5\s?ton/.test(m)) return "acc15"; if (/2\s?ton/.test(m)) return "acc2"; if (/1\s?ton/.test(m)) return "acc1"; return null; } },
    { field: "ac_type", options: ["act_split", "act_window"],
      detect: (m) => { m = lc(m); if (/split/.test(m)) return "act_split"; if (/window/.test(m)) return "act_window"; return null; } },
    { field: "ac_inverter", options: ["acinv", "acnon"],
      detect: (m) => { m = lc(m); if (/non.?inverter/.test(m)) return "acnon"; if (/inverter/.test(m)) return "acinv"; return null; } },
  ],
  app_micro: [
    { field: "capacity", options: ["mwcap_s", "mwcap_m", "mwcap_l"],
      detect: (m) => { m = lc(m); const q = m.match(/(\d{2})\s?(l|ltr|litre|liter)/); if (!q) return null; const n = parseInt(q[1], 10); return n < 20 ? "mwcap_s" : n <= 30 ? "mwcap_m" : "mwcap_l"; } },
    { field: "mw_type", options: ["mw_solo", "mw_grill", "mw_conv"],
      detect: (m) => { m = lc(m); if (/convection/.test(m)) return "mw_conv"; if (/grill/.test(m)) return "mw_grill"; if (/solo/.test(m)) return "mw_solo"; return null; } },
  ],
  app_tv: [
    { field: "screen_size", options: ["scr_24", "scr_32", "scr_40", "scr_43", "scr_50", "scr_55", "scr_65", "scr_75"], detect: detectScreen },
  ],
  app_other: [],
};
// Category-specific accessory question. null = do not ask (not resale-material).
export const ACCESSORY_SETS = {
  mobile: ["charger", "box", "both", "none"],
  laptop: ["charger", "box", "both", "none"],
  tablet: ["charger", "box", "both", "none"],
  smartwatch: ["charger", "box", "both", "none"],
  gaming: ["g_controller", "g_cable", "g_box", "g_complete", "g_missing"],
  earbuds: ["e_case", "e_box", "e_cable", "e_none"],
  tv: null,
  camera: null,
  appliance: null,
  accessory: null,
  others: null,
  furniture: null,
};

// Lightweight autocomplete suggestions per category.
export const SUGGESTIONS = {
  mobile: ["iPhone 15 Pro Max 256GB", "iPhone 14 128GB", "Samsung Galaxy S24 Ultra", "OnePlus 12", "Redmi Note 13 Pro", "Realme 12 Pro", "Vivo V30", "Google Pixel 8"],
  laptop: ["MacBook Air M2 8GB/256GB", "MacBook Pro M3", "Dell XPS 13 i7", "HP Pavilion 15 i5", "Lenovo ThinkPad X1", "Asus ROG Strix Ryzen 7", "Acer Aspire 7"],
  tablet: ["iPad Air 128GB WiFi", "iPad Pro 11", "Samsung Galaxy Tab S9", "OnePlus Pad", "Lenovo Tab P12"],
  tv: ["Samsung Crystal 55 inch", "LG OLED C3 55 inch", "Sony Bravia 65 inch", "Mi TV 43 inch", "OnePlus TV 50 inch"],
  gaming: ["PS5 Disc Edition", "PS5 Digital Edition", "Xbox Series X", "Xbox Series S", "Nintendo Switch OLED"],
  camera: ["Canon EOS R6", "Sony Alpha A7 IV", "Nikon Z6 II", "Fujifilm X-T5", "GoPro Hero 12"],
  smartwatch: ["Apple Watch Series 9 GPS", "Samsung Galaxy Watch 6", "Apple Watch Ultra 2", "Noise ColorFit Pro", "boAt Wave"],
  earbuds: ["AirPods Pro 2", "Samsung Galaxy Buds 2 Pro", "OnePlus Buds 3", "boAt Airdopes 141", "Sony WF-1000XM5"],
  appliance: ["Samsung 253L Double Door", "LG 7 Kg Front Load", "Voltas 1.5 Ton Split Inverter", "IFB 20L Convection", "Whirlpool", "Godrej"],
  accessory: ["Charger", "USB-C Cable", "Power Bank", "Wireless Keyboard", "Mouse", "Phone Case"],
  others: [],
  furniture: ["Wooden almirah", "3 seater sofa", "Queen size bed", "Study table", "Office chair", "6 seater dining table"],
};

export function getCategory(id) {
  return CATEGORIES.find((c) => c.id === id) || CATEGORIES[CATEGORIES.length - 1];
}
